<template>
<div class="container-fluid">
  <div v-for="attribute in errors" class="alert alert-danger" :key="attribute.field">
      {{attribute.value}}
  </div>
  <h4 class="m-3">Изменение баннера</h4>
  <el-form  :model="form" label-width="180px" label-position="left" id="uploadForm" name="uploadForm" enctype="multipart/form-data">
    <el-form-item label="Название" prop="title">
      <el-input v-model="form.title"></el-input>
    </el-form-item>
    <el-form-item label="Описание" prop="description">
      <el-input type="textarea" v-model="form.description"></el-input>
    </el-form-item>
    <el-form-item label="Название кнопки" prop="linkTitle">
      <el-input v-model="form.btnText"></el-input>
    </el-form-item>
    <el-form-item label="Ссылка" prop="link">
      <el-input v-model="form.link"></el-input>
    </el-form-item>
      <el-form-item label="Сортировка">
          <el-input type="number" min="0" v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
          <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
       <el-form-item label="Разделы каталога">
        <el-row>
          <el-button size="small" type="primary" @click="toggleDialog()">Выбрать</el-button>
        </el-row>
        <el-row v-if="selectedSections.length">
            <el-tag closable @close="handleDeleteCat">
              Выбрано: {{ selectedSections.length }}
            </el-tag>
        </el-row>
        
      </el-form-item>
      <el-form-item label="Изображение">
      <el-upload
      action=""
      list-type="picture"
      :limit="1"
      :auto-upload="false"
      :on-change="handleChange"
      >
        <el-button size="small" type="primary">Добавить Изображение</el-button>
      </el-upload>
      </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="storeBanner()">Изменить</el-button>
      <el-button @click="back">Отмена</el-button>
    </el-form-item>
  </el-form>
  <CatalogSectionDialog
  v-if="$store.getters.showCatalogSectionDialog"
  :items-payload="selectedSections"
  :is-multiple="true"
  :returns-ids="true"
  @saveItems="onSaveItems"
  />
</div>
</template>

<script>
import axios from "axios";
import typeObjConfig from '../../composable/config/banner-type-object.config'
import getFileList from '../../composable/utils/getFileList'
import useFormData from '../../composable/useFormData'
import getErrors from '../../composable/utils/getErrors';
import CatalogSectionDialog from '../CatalogSectionDialog'

export default {
  components: {CatalogSectionDialog},
name: "BannerCreate",
  data: function (){
    return {
     form: {
        title: '',
        description: '',
        link:'',
        btnText:'',
        sort: 1,
        activity: true,
        image: '',
        sections: [],
      },
      selectedSections: [],
      fileList: [],
      errors:[],
      status:0,
      typeObjConfig,
      idBanner: this.$route.params.id,
    }
  },
  mounted() {
    this.initialize()
  },
  methods:{
    getBanner: function (){
      axios.get('/banner/'+this.idBanner).then((response)=>
          {
            this.setFormData(response.data)
            this.setFileList(response.data.img)
          }
      ).catch((errors)=>{
          if(errors.response?.status === 401){
              this.$router.push('/login');
          }
          console.log(errors)
      });
    },

    back(){
      this.$router.go(-1)      
    },
    handleChange(v){
      this.form.image = v?.raw || undefined
    },
    
    storeBanner(){
      const { execute } = useFormData()
      const data = execute().setFields([
        'image',
        'title',
        'slug',
        'description',
        'link',
        'btnText',
        'sort',
        'activity',
        'sections'
      ]).getFormData(this.form)
      
      axios.post('banner/' + this.idBanner, data).then((response)=>{
        this.status = response.status;
        this.errors ='';
        this.back()
      }).catch((errors)=>{

        if(errors.response.status === 401){
          this.$router.push('/login');
          return
        } else if(errors.response.status === 422) {
          this.setErrors(errors.response.data.errors)
        } else {
          this.setErrors([])
        }
      });
    },
    initialize(){
      this.getBanner();
    },
    setFormData(value) {
      if (value) {
        this.form.title = value?.title || '';
        this.form.description = value?.description || '';
        this.form.link = value?.link || '';
        this.form.btnText = value?.btn_text || '';
        this.form.sort = value?.sort || 0;
        this.form.activity = value?.activity || false;
        this.form.sections = value?.sections?.map((e) => e.id)
        this.selectedSections = value?.sections?.map((e) => e.id) ?? [];
      }
    },
    setFileList(value){
      this.fileList = getFileList(value)
    },
    setErrors(err) {
      const er = getErrors(err)
      this.errors = er
    },
    toggleDialog() {
      this.$store.commit('showCatalogSectionDialog', !this.$store.getters.showCatalogSectionDialog);
    },
    setFormSection(){
      this.form.sections = this.selectedSections.map(e => e) ?? ''
    },
    handleDeleteCat(){
      this.selectedSections = []
      this.setFormSection()
    },
    onSaveItems(items) {
      this.selectedSections = items
      this.setFormSection()
    }
  }
}
</script>

<style>

</style>